import React from 'react';
import { useAuth } from 'react-oidc-context';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { authActions } from '@lifeomic/phc-web-toolkit/src/redux/modules/auth';

import LoadingViewComponent from '../../common/Loading';
import urls from '../../../util/urls';

export const AuthRedirect: React.FC = () => {
  const auth = useAuth();
  const history = useHistory();
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(authActions.setAuthFromOIDCFlow(auth));
    history.push(urls.app.home());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth]);

  return <LoadingViewComponent />;
};
